import UniversalMediaElement from '../widgets/js/UniversalMediaElement';
import { 
  ContainerArticle, 
  ContainerFood,
  SpanForListItemsNull
} from '../js/Styles'; // Ajusta la ruta según tu estructura
import Food from '../widgets/js/Food';

import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";


import axios from 'axios';

function Item1InFoodMenu() {

  const [products, setProducts] = useState([]); // Estado para almacenar los productos
  const [images_for_carousel, setImagesForCarousel] = useState([]); // Estado para almacenar las imagenes del carrousel
  const apiDomain = process.env.REACT_APP_DOMAIN_API;
  const withSSL = process.env.REACT_APP_SSL;
  const { category_product_id } = useParams();
  
  const get_list_objects = async() => {

    await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/products/${category_product_id}/`).then(
      response => {
        //console.log(response.data);
        setProducts(response.data)
      }

    ).catch(
        error => console.log(error)
    )

    await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/media_content/${category_product_id}/`).then(
      response => {
          const imagenes = response.data[0].imagenes.map(imagen => imagen.imagen);
          setImagesForCarousel(imagenes);
      }
    ).catch(
        error => console.log(error)
    )
  }

  useEffect(() => {
    get_list_objects();
  }, [category_product_id]);

  return (
    <div>
      <article id="container-article1">
      </article>
      {
        products.length > 0 ?
        <ContainerArticle style={{
          paddingTop: "20px"
        }}>
          <ContainerFood>
            {
              products.length > 0 ? (
                products.map((object, index) => (
                  document.getElementById("container-article1").scrollIntoView({
                    behavior: "smooth", // Hace el desplazamiento suave
                    block: "start" // Alinea la parte superior del div en la parte superior de la ventana
                  }),
                  <Food food={object} index={index} key={index} />
                ))
              ) : (
                <SpanForListItemsNull>Cargando alimentos..</SpanForListItemsNull>
              )
            }
          </ContainerFood>
        </ContainerArticle>
        :
        <div style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: "2rem"
        }}>
            <span>Cargando ...</span>
        </div>
      }
    </div>
  );
}

export default Item1InFoodMenu;
